/* Copyright (c) 2018-2022, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';

export enum AppWindowNames {
    Gfe = 'gfeclient',
    Gfn = 'gfnclient',
    Igo = 'shareclient',
    Forager = 'foragerclient',
    Nvcpl = 'controlPanelclient',
    Oogg = 'ooggclient',
    Vdkplaytest = 'vdkplaytest',
    Nvapp = 'nvapp',
    Gdn = 'gdnclient'
}

@Injectable()
export class WindowConfig {
    name: AppWindowNames;
}
